export default "__VITE_ASSET__f5e81cef__"